export const RIGHT_NAV_TRANSLATION_BASE_PATH = `Right_Nav`;
